var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "renewModal", role: "dialog", "data-backdrop": "static" },
    },
    [
      _c("div", { staticClass: "modal-dialog upgrade-account-modal" }, [
        _c(
          "div",
          { staticClass: "modal-content first-modal-content" },
          [
            _c("div", { staticClass: "modal-header upgradeModal-bgcolor" }, [
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "data-target": "#renewModal" },
                  on: { click: _vm.closePopup },
                },
                [_vm._v(" × ")]
              ),
              _vm._m(0),
            ]),
            _c("div", { staticClass: "modal-body confirm-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-7 col-md-7 col-sm-7 text-left" },
                      [
                        _c("div", { staticClass: "upgrade-team" }, [
                          _vm._v("Team Members"),
                        ]),
                        _c("div", { staticClass: "current-limit" }, [
                          _vm._v(
                            "(Current members: " +
                              _vm._s(_vm.currentUtilization) +
                              ")"
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-lg-5 col-md-5 col-sm-5" },
                      [
                        _vm.team_member
                          ? _c("div", { staticClass: "additional-price" }, [
                              _vm._v(" Price: "),
                              _vm.team_member.label !== "5 members"
                                ? _c("span", [_vm._v("Additional ")])
                                : _vm._e(),
                              _vm._v(" " + _vm._s(_vm.team_member.desc) + " "),
                            ])
                          : _vm._e(),
                        _c("multiselect", {
                          staticClass:
                            "multiselect-single-dropdown max-height-150",
                          class: !_vm.team_member ? "un-selected" : "",
                          attrs: {
                            "show-labels": false,
                            "allow-empty": false,
                            searchable: false,
                            options: _vm.team_members,
                            label: "label",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "singleLabel",
                              fn: function (props) {
                                return [
                                  _c("span", { staticClass: "option_name" }, [
                                    _vm._v(_vm._s(props.option.label)),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "option",
                              fn: function (props) {
                                return [
                                  _c("span", { staticClass: "option_name" }, [
                                    _vm._v(_vm._s(props.option.label)),
                                  ]),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.team_member,
                            callback: function ($$v) {
                              _vm.team_member = $$v
                            },
                            expression: "team_member",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-12 col-sm-12 col-xs-12 text-center adjust-service",
                      },
                      [
                        _vm._v(
                          " * Some options may not be available, adjust the service’s current amounts to enable them "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "modal-footer cancelModal-bgcolor" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-6 col-sm-6 col-md-6 p-0 text-left please-cancel-btn",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn emergo-white-button wd-250",
                      on: {
                        click: function ($event) {
                          return _vm.closePopup()
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "col-lg-6 col-sm-6 col-md-6 p-0 text-right" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn emergo-blue-button wd-250",
                      on: {
                        click: function ($event) {
                          return _vm.renewAccount(false)
                        },
                      },
                    },
                    [_vm._v(" Renew Add-ons ")]
                  ),
                ]
              ),
            ]),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-title" }, [
      _c("div", { staticClass: "upgrade-service-para" }, [
        _c("span", [_vm._v("Renew Account Add-on(s)")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }